<template>
  <loader-full v-if="loaded" :text="'Переход на оплату договора: '+this.$route.params.id"/>
  <section v-else class="d-flex justify-content-center align-items-center h-100" style="flex-direction: column">
    <i class="ki-duotone ki-information fs-3x mb-3">
      <span class="path1"></span>
      <span class="path2"></span>
      <span class="path3"></span>
    </i>
    <span style="font-weight: 600;color: #3F4254;">{{ message }}</span>
  </section>
  <custom-notification/>
</template>

<script>
import CustomNotification from "@/components/Main/CustomNotification.vue";
import {showPaymentForm}  from '@/services/payment'
import LoaderFull         from '@/components/Main/LoaderFull'
import states             from '@/helpers/states'
import axios              from 'axios'

export default {
  name: 'EpayPayment',
  components: {LoaderFull, CustomNotification},
  data() {
    return {
      loaded:   true,
      message:  null,
    }
  },
  mounted() {
    this.getPolicy()
  },
  methods: {
    payed(invoiceId, amount, auth, terminal) {
      let data = {
        postLink: states.getBackEndUrlByState()+'api/epay/order/result/'+this.$route.params.id,
      }
      showPaymentForm(invoiceId, amount, data, 'Оплата в интернет магазине', this.res, auth, terminal);
    },
    res(val) {},
    getPolicy() {
      axios.get('/api/get-to-epay/'+this.$route.params.id)
          .then(res => {
            if (!res.data.result) {
              this.loaded  = false
              this.message = res.data.errors[0]
              this.$notifyError(res.data)
            } else {
              this.payed(res.data.data.invoice, res.data.data.amount, res.data.data.auth, res.data.data.terminal)
            }
          })
          .catch(err => {
            console.log(err)
          })
    }
  }
}
</script>

<style scoped>

</style>